import React, { useEffect, useState } from 'react';
import BasePage from './BasePage';
import axios from 'axios';
import config from '../../config';
import '../styles/pages.css';

export default function Contacts() {
  const [contacts, setContacts] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          try {
            const res = await axios.get(`${config.apiUrl}/api/company/my-company`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            setCompany(res.data.company);
          } catch (err) {
            // если нет доступа к компании, просто продолжаем
          }
        }

        const resContacts = await axios.get(`${config.apiUrl}/api/settings/getContacts`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setContacts(resContacts.data);
      } catch (err) {
        console.error('Ошибка при получении контактов:', err.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <BasePage title="Контакты">
      
      <div className="contacts-container">
        {loading ? (
          <div className="loading">Загрузка контактов...</div>
        ) : contacts ? (
          <>
            <div className="contacts-header">
              <h2>Свяжитесь с нами</h2>
              <p>Выберите удобный для вас способ связи</p>
            </div>

            <div className="contacts-grid">
              {(company?.phone || contacts?.phone) && (
                <a href={`tel:${company?.phone || contacts?.phone}`} className="contact-card">
                  <div className="contact-icon">📞</div>
                  <h3>Телефон</h3>
                  <p>{company?.phone || contacts?.phone}</p>
                  <span className="call-btn">Позвонить</span>
                </a>
              )}

              {company?.email && (
                <div className="contact-card">
                  <div className="contact-icon">📧</div>
                  <h3>Email</h3>
                  <p>{company.email}</p>
                </div>
              )}

              {company?.website && (
                <a href={company.website.startsWith('http') ? company.website : `https://${company.website}`} target="_blank" rel="noopener noreferrer" className="contact-card">
                  <div className="contact-icon">🌐</div>
                  <h3>Сайт</h3>
                  <p>{company.website}</p>
                </a>
              )}

              {company?.address && (
                <div className="contact-card">
                  <div className="contact-icon">📍</div>
                  <h3>Адрес</h3>
                  <p>{company.address}</p>
                </div>
              )}

              {contacts?.whatsappLink && (
                <a href={contacts.whatsappLink} target="_blank" rel="noopener noreferrer" className="contact-card whatsapp">
                  <div className="contact-icon">💬</div>
                  <h3>WhatsApp</h3>
                  <p>{contacts.whatsappPhone || 'Напишите нам'}</p>
                  <span className="msg-btn">Написать</span>
                </a>
              )}

              {contacts?.telegramLink && (
                <a href={contacts.telegramLink} target="_blank" rel="noopener noreferrer" className="contact-card telegram">
                  <div className="contact-icon">✈️</div>
                  <h3>Telegram</h3>
                  <p>{contacts.telegramId || 'Наш канал'}</p>
                  <span className="msg-btn">Перейти</span>
                </a>
              )}

              {contacts?.instagram && (
                <a href={`https://instagram.com/${contacts.instagram}`} target="_blank" rel="noopener noreferrer" className="contact-card instagram">
                  <div className="contact-icon">📸</div>
                  <h3>Instagram</h3>
                  <p>@{contacts.instagram}</p>
                  <span className="follow-btn">Следить</span>
                </a>
              )}
            </div>
          </>
        ) : (
          <div className="no-contacts">Контакты не доступны в данный момент</div>
        )}
      </div>
    </BasePage>
  );
}
